export const saveToClipboard = (text: string) => {
    if (window.navigator?.clipboard) {
        window.navigator.clipboard.writeText(text);
    } else {
        // @ts-ignore
        window.clipboardData?.setData('Text', text);
    }
};
